<template>
  <div class="template-connected">
    <div id="container">
      <div class="block-flat document">
        <div class="block-content h-100">
          <fieldset>
            <legend>Visualisation des statistiques</legend>
          </fieldset>
          <iframe
            class="visu-doc"
            :src="'https://grafana.clicmap.fr/goto/tSHscUEGz'"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Statistics",
};
</script>

<style scoped></style>
